import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPin16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconPin16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m10.329 7.67-.358.236-.072.414-.4 2.284c-.068.394-.567.548-.858.265L4.828 7.166a.489.489 0 0 1 .274-.834l2.35-.388.427-.07.243-.347 2.04-2.914a.517.517 0 0 1 .778-.071l2.462 2.391a.484.484 0 0 1-.074.756zM4.932 5.36l2.35-.387 2.04-2.914c.537-.766 1.66-.87 2.335-.214l2.462 2.392a1.452 1.452 0 0 1-.22 2.267l-3 1.981-.4 2.283c-.206 1.184-1.702 1.647-2.575.798L6.373 10.06l-3.62 3.515a.52.52 0 0 1-.717 0 .483.483 0 0 1 0-.697l3.62-3.515-1.545-1.5c-.874-.849-.397-2.302.821-2.503"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPin16);
